export const createGetPairAddressQuery = (token0, token1) => {
  return `https://graphql.terraformer.xyz/graphql?query={
        pairByTokens (token0: "${token0}", token1: "${token1}") {
          pairAddress
        }
      }`;
};
